var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loader",attrs:{"data-flex":"root center"}},[_c('div',{staticClass:"loader__logo"},[_c('img',{attrs:{"src":require("@/assets/img/logo-sign2.png"),"alt":"loading"}}),_c('strong',[_vm._v("Loading...")])])])}]

export { render, staticRenderFns }